import $ from 'jquery'
import Swiper from './utils/getSwiper'
import { positionImages } from './positionImages'

function init () {
  $('.storytelling').each(function () {
    var $storytelling = $(this)
    initSlider($storytelling)
    $(window).resize(function () {
      positionImages($storytelling.find('.img-fill'))
    })
    $(this).on('load', positionImages($storytelling.find('.img-fill')))
    $(this)
      .find('[data-color]')
      .each(() => $(this).css('color', $(this).data('color')))
  })
}

function initSlider (container) {
  let imageWrapper = container.find('.story-image-wrapper'),
    images = container.find('.story-image-set img'),
    swiperContainer = container.find('.swiper-container'),
    swiperLastArrow = container.find('.story-arrow-left-wrapper .story-arrow'),
    swiperNextArrow = container.find('.story-arrow-right-wrapper .story-arrow')

  if (!swiperContainer.hasClass('single')) {
    let storySwiper = new Swiper(swiperContainer.get(0), {
      loop: true,
      speed: 500,
      autoHeight: true,
      watchSlidesVisibility: true,
      threshold: 10,
      longSwipesRatio: 0.3,
      shortSwipes: false,
      on: {
        init: function () {
          imageWrapper
            .find('.storytelling-videoplayer-wrapper[data-storytelling-slide-id=\'0\']')
            .addClass('active')
          container.find('[data-storytelling-document-id=0]').show()
        },
      },
      navigation: {
        nextEl: swiperNextArrow.get(0),
        prevEl: swiperLastArrow.get(0),
      },
      pagination: {
        el: '.storytelling-swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })

    storySwiper.on('slideChange', function () {
      container.find('[data-storytelling-document-id]').hide()
      container.find('[data-storytelling-document-id=\'' + storySwiper.realIndex + '\']').show()
      imageWrapper.find('.storytelling-videoplayer-wrapper').removeClass('active')
      imageWrapper
        .find('.storytelling-videoplayer-wrapper[data-storytelling-slide-id=\'' + storySwiper.realIndex + '\']')
        .addClass('active')
    })

    imageWrapper.on('swipeleft', function () {
      storySwiper.slideNext()
    })
    imageWrapper.on('swiperight', function () {
      storySwiper.slidePrev()
    })
  } else {
    imageWrapper.find('img').removeClass('story-animation story-animate-transition-delay')
  }
}

export default {
  init,
}
